<template>
	<div class="home-new-view">
		<section class="hero">
			<div class="hero__content">
				<p class="hero__eyebrow">苏梵互动 · 全球数字体验提供商</p>
				<h1>为成长型企业打造简约大气的官网体验</h1>
				<p class="hero__desc">
					我们整合品牌策略、视觉叙事与前沿技术，帮助企业向世界传递可信赖的数字形象。
				</p>
				<div class="hero__actions">
					<button class="btn btn--primary">立即咨询</button>
					<button class="btn btn--ghost">下载方案</button>
				</div>
			</div>
			<div class="hero__stats">
				<div v-for="item in stats" :key="item.label" class="stat">
					<p class="stat__value">{{ item.value }}</p>
					<p class="stat__label">{{ item.label }}</p>
					<p class="stat__desc">{{ item.desc }}</p>
				</div>
			</div>
		</section>

		<section class="section section--about">
			<div class="section__header">
				<p class="eyebrow">ABOUT</p>
				<h2>关于我们</h2>
				<p>聚焦品牌官网、企业服务门户、互动展示等多元场景，链接企业与用户。</p>
			</div>
			<div class="about__grid">
				<article class="about-card" v-for="block in aboutBlocks" :key="block.title">
					<h3>{{ block.title }}</h3>
					<p>{{ block.desc }}</p>
					<ul>
						<li v-for="tag in block.tags" :key="tag">{{ tag }}</li>
					</ul>
				</article>
			</div>
		</section>

		<section class="section section--services">
			<div class="section__header">
				<p class="eyebrow">SERVICES</p>
				<h2>核心能力</h2>
				<p>从洞察规划到上线交付，确保品牌调性与交互体验高度统一。</p>
			</div>
			<div class="service__grid">
				<article v-for="service in services" :key="service.title" class="service-card">
					<div class="service-card__icon">{{ service.icon }}</div>
					<h3>{{ service.title }}</h3>
					<p>{{ service.desc }}</p>
					<ul>
						<li v-for="point in service.points" :key="point">{{ point }}</li>
					</ul>
				</article>
			</div>
		</section>

		<section class="section section--showcase">
			<div class="section__header">
				<p class="eyebrow">SHOWCASE</p>
				<h2>精选案例</h2>
				<p>以模块化组件搭建首页骨架，二级页面可按需延伸。</p>
			</div>
			<div class="showcase__list">
				<article v-for="caseItem in cases" :key="caseItem.name" class="showcase-card">
					<div class="showcase-card__cover">
						<div class="cover__gradient"></div>
						<span>{{ caseItem.industry }}</span>
					</div>
					<div class="showcase-card__body">
						<h3>{{ caseItem.name }}</h3>
						<p>{{ caseItem.desc }}</p>
						<div class="chips">
							<span v-for="chip in caseItem.chips" :key="chip">{{ chip }}</span>
						</div>
					</div>
				</article>
			</div>
		</section>

		<section class="section section--cta">
			<div class="cta__content">
				<h2>准备升级企业官网？</h2>
				<p>保留核心区块即可上线，后续可平滑扩展到多语言、会员、营销闭环等能力。</p>
			</div>
			<div class="cta__actions">
				<button class="btn btn--primary btn--lg">预约演示</button>
				<button class="btn btn--ghost btn--lg">获取需求文档</button>
			</div>
		</section>

		<section class="section section--contact">
			<div class="contact__panel">
				<h3>联系我们</h3>
				<p>商务合作 · 政企项目 · 战略伙伴</p>
				<div class="contact__grid">
					<div>
						<p class="label">邮箱</p>
						<p>business@soofun.com</p>
					</div>
					<div>
						<p class="label">电话</p>
						<p>+86 755 8888 6666</p>
					</div>
					<div>
						<p class="label">地址</p>
						<p>深圳市南山区科兴科学园 A 座 16F</p>
					</div>
				</div>
			</div>
			<form class="contact__form">
				<label>
					<span>姓名</span>
					<input type="text" placeholder="请输入您的姓名" />
				</label>
				<label>
					<span>公司</span>
					<input type="text" placeholder="例如：苏梵互动科技" />
				</label>
				<label>
					<span>联系方式</span>
					<input type="text" placeholder="邮箱或手机号" />
				</label>
				<label>
					<span>项目需求</span>
					<textarea rows="4" placeholder="请简单描述您的项目场景"></textarea>
				</label>
				<button type="button" class="btn btn--primary btn--full">提交信息</button>
			</form>
		</section>
	</div>
</template>

<script>
export default {
	name: 'HomeNewView',
	data() {
		return {
			stats: [
				{ value: '12+', label: '行业赛道', desc: '金融、能源、文化、政企等场景积累' },
				{ value: '180+', label: '交付案例', desc: '兼顾品牌体验与性能表现' },
				{ value: '98%', label: '客户续约率', desc: '长期陪伴企业数字化升级' }
			],
			aboutBlocks: [
				{
					title: '以战略为起点',
					desc: '从用户洞察、业务目标到品牌叙事，形成统一的体验蓝图。',
					tags: ['品牌定位', '用户旅程', '内容策划']
				},
				{
					title: '以设计为语言',
					desc: '遵循极简视觉体系，融合动效、留白、真实影像打造高级感。',
					tags: ['视觉系统', '组件化设计', '互动动效']
				},
				{
					title: '以技术为落地',
					desc: '兼容 PC / 移动端，支持多语种、CMS 管理、云端部署等扩展能力。',
					tags: ['前端工程化', '性能优化', '可观测性']
				}
			],
			services: [
				{
					icon: '🧭',
					title: '数字策略咨询',
					desc: '明确官网定位、受众与内容结构，夯实项目底层逻辑。',
					points: ['业务工作坊', '信息架构规划', '内容指南']
				},
				{
					icon: '🎨',
					title: '品牌体验设计',
					desc: '用模块化组件打造一致的视觉语言与互动体验。',
					points: ['品牌视觉', '交互动效', '响应式适配']
				},
				{
					icon: '💡',
					title: '前端工程交付',
					desc: '基于 Vue 体系的可持续代码架构，便于长期迭代维护。',
					points: ['组件化开发', '性能治理', '可持续运维']
				}
			],
			cases: [
				{
					name: '星环能源集团',
					industry: '新能源 · 上市企业',
					desc: '以科技蓝为主色，打造“零碳”主题官网，展现技术实力与 ESG 责任。',
					chips: ['多语言', '股东关系', '数据可视化']
				},
				{
					name: 'ONE Design Lab',
					industry: '创意机构 · 国际',
					desc: '强调留白与动效节奏，突出作品质感与团队理念，兼顾移动端体验。',
					chips: ['案例媒体库', '沉浸动效', '自适应布局']
				},
				{
					name: '澜芯数科',
					industry: 'ToB 科技 · 成长型',
					desc: '以场景叙事方式展示产品组合，通过三步引导促进转化咨询。',
					chips: ['产品矩阵', '解决方案', '线索收集']
				}
			]
		};
	}
};
</script>

<style scoped>
:root {
	--color-bg: #f5f6fa;
	--color-card: #ffffff;
	--color-primary: #1f4cfe;
	--color-text: #111322;
	--color-muted: #5f6577;
	--radius-lg: 28px;
	--radius-md: 20px;
	--radius-sm: 12px;
}

.home-new-view {
	min-height: 100vh;
	padding: 64px 0 120px;
	background: linear-gradient(180deg, #101423 0%, #0f1729 35%, #0c1224 100%);
	font-family: 'Helvetica Neue', 'PingFang SC', 'Microsoft YaHei', sans-serif;
	color: #ffffff;
}

section {
	width: min(1200px, 92vw);
	margin: 0 auto;
}

.hero {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
	gap: 40px;
	align-items: center;
	padding: 40px 0 80px;
}

.hero__eyebrow {
	font-size: 14px;
	letter-spacing: 0.5em;
	color: rgba(255, 255, 255, 0.7);
	text-transform: uppercase;
	margin-bottom: 16px;
}

.hero__content h1 {
	font-size: clamp(32px, 5vw, 56px);
	line-height: 1.2;
	margin-bottom: 24px;
}

.hero__desc {
	font-size: 16px;
	color: rgba(255, 255, 255, 0.8);
	margin-bottom: 32px;
	max-width: 520px;
}

.hero__actions {
	display: flex;
	gap: 16px;
	flex-wrap: wrap;
}

.hero__stats {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
	gap: 16px;
}

.stat {
	padding: 24px;
	background: rgba(255, 255, 255, 0.05);
	border-radius: var(--radius-md);
	backdrop-filter: blur(6px);
	border: 1px solid rgba(255, 255, 255, 0.08);
}

.stat__value {
	font-size: 36px;
	font-weight: 600;
	margin-bottom: 8px;
}

.stat__label {
	font-size: 14px;
	color: rgba(255, 255, 255, 0.7);
}

.stat__desc {
	font-size: 13px;
	color: rgba(255, 255, 255, 0.55);
	margin-top: 4px;
}

.section {
	background: var(--color-card);
	color: var(--color-text);
	border-radius: var(--radius-lg);
	padding: 56px 56px 64px;
	margin-bottom: 32px;
	box-shadow: 0 40px 90px rgba(15, 23, 41, 0.25);
}

.section--cta {
	background: linear-gradient(135deg, #1f4cfe, #6c7bff);
	color: #fff;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: 24px;
}

.section--contact {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
	gap: 32px;
}

.section__header {
	margin-bottom: 40px;
}

.section__header h2 {
	font-size: 32px;
	margin-bottom: 12px;
}

.section__header p {
	color: var(--color-muted);
}

.eyebrow {
	font-size: 13px;
	letter-spacing: 0.4em;
	color: var(--color-primary);
	margin-bottom: 8px;
}

.about__grid,
.service__grid {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
	gap: 20px;
}

.about-card,
.service-card {
	padding: 28px;
	border-radius: var(--radius-md);
	border: 1px solid rgba(31, 76, 254, 0.12);
	background: #fdfdff;
}

.about-card h3,
.service-card h3 {
	font-size: 20px;
	margin-bottom: 12px;
}

.about-card p,
.service-card p {
	font-size: 14px;
	color: var(--color-muted);
	margin-bottom: 16px;
}

.about-card ul,
.service-card ul {
	list-style: none;
	padding: 0;
	margin: 0;
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}

.about-card li,
.service-card li {
	background: rgba(31, 76, 254, 0.08);
	padding: 6px 12px;
	border-radius: 999px;
	font-size: 12px;
	color: var(--color-primary);
}

.service-card__icon {
	font-size: 32px;
	margin-bottom: 16px;
}

.showcase__list {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
	gap: 24px;
}

.showcase-card {
	border-radius: var(--radius-md);
	overflow: hidden;
	border: 1px solid rgba(31, 76, 254, 0.08);
	background: #fdfdff;
	display: flex;
	flex-direction: column;
}

.showcase-card__cover {
	height: 160px;
	background: #101423;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
}

.cover__gradient {
	position: absolute;
	inset: 0;
	background: radial-gradient(circle at top, rgba(111, 127, 255, 0.6), transparent);
}

.showcase-card__cover span {
	position: relative;
	z-index: 1;
	font-size: 14px;
	letter-spacing: 0.2em;
	text-transform: uppercase;
}

.showcase-card__body {
	padding: 24px;
}

.showcase-card__body h3 {
	margin-bottom: 12px;
	font-size: 20px;
}

.showcase-card__body p {
	color: var(--color-muted);
	margin-bottom: 16px;
}

.chips {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}

.chips span {
	padding: 6px 12px;
	border-radius: 999px;
	background: rgba(31, 76, 254, 0.1);
	font-size: 12px;
	color: var(--color-primary);
}

.cta__content h2 {
	font-size: 32px;
	margin-bottom: 12px;
}

.cta__content p {
	color: rgba(255, 255, 255, 0.85);
}

.contact__panel {
	background: rgba(31, 76, 254, 0.08);
	border-radius: var(--radius-md);
	padding: 32px;
}

.contact__panel h3 {
	font-size: 24px;
	margin-bottom: 8px;
}

.contact__panel p {
	margin-bottom: 20px;
	color: var(--color-muted);
}

.contact__grid {
	display: grid;
	gap: 16px;
}

.contact__grid .label {
	font-size: 12px;
	text-transform: uppercase;
	letter-spacing: 0.2em;
	color: var(--color-primary);
	margin-bottom: 4px;
}

.contact__form {
	display: grid;
	gap: 16px;
}

.contact__form label {
	display: flex;
	flex-direction: column;
	gap: 8px;
	font-size: 14px;
	color: var(--color-muted);
}

.contact__form input,
.contact__form textarea {
	border: 1px solid rgba(17, 19, 34, 0.1);
	border-radius: var(--radius-sm);
	padding: 12px 16px;
	font-size: 14px;
	font-family: inherit;
	color: var(--color-text);
	background: #fff;
}

.btn {
	border: none;
	border-radius: 999px;
	padding: 12px 28px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.25s ease;
}

.btn--primary {
	background: var(--color-primary);
	color: #fff;
	box-shadow: 0 20px 40px rgba(31, 76, 254, 0.35);
}

.btn--primary:hover {
	transform: translateY(-2px);
	box-shadow: 0 24px 50px rgba(31, 76, 254, 0.45);
}

.btn--ghost {
	background: transparent;
	color: inherit;
	border: 1px solid rgba(255, 255, 255, 0.4);
}

.section--services .btn--ghost {
	color: var(--color-primary);
	border-color: rgba(31, 76, 254, 0.4);
}

.btn--lg {
	padding: 14px 32px;
	font-size: 16px;
}

.btn--full {
	width: 100%;
}

@media (max-width: 768px) {
	.section {
		padding: 32px 24px 40px;
	}

	.hero {
		padding-top: 0;
	}

	.hero__actions {
		width: 100%;
	}
}
</style>

